module.exports = __webpack_public_path__ + "img/webpush.8b543514.png";